<template>
	<div style="width:1600px; height:830px;" v-on:keyup.esc="close()">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text">Invoice Date</em>
				<span class="mgr_5"> <CustomDatePicker v-model="bo_date_from"/> ~ <CustomDatePicker v-model="bo_date_to"/></span>
				<a href="javascript:;" class="search_bt" @click="boSearch()">Search</a>
				<a href="javascript:;" class="gray_bt" @click="boReset()">Reset</a>
			</div>
		</div>
		<div class="view_inner">
			<div class="fixed-table-container" style="padding-top:0px;">
				<div class="table-wrapper" style="height: 97%">
					<table class="list_tbl sticky_list_tbl">
						<thead>
							<tr>
								<th width="10px;"><input type="checkbox" @change="selectBoAll()" v-model="boAllSelected" /></th>
								<th width="50px;">Sales Code</th>
								<th width="100px;">Sales Name</th>
								<!-- <th width="60px;">Ship To</th>
								<th width="180px;">Ship To Name</th>
								<th width="60px;">Bill To</th>
								<th width="100px;">Bill To Name</th> -->
								<th width="90px;">{{ headers.class }} Code</th>
								<th width="200px;">{{ headers.class }} Name</th>
								<th width="80px;">Color</th>
								<th width="100px;">S/O No</th>
								<th width="80px;">S/O Date</th>
								<th width="100px;">Inv. No</th>
								<th width="80px;">Inv. Date</th>
								<th width="60px;">Price</th>
								<th width="50px;">Order Qty.</th>
								<th width="50px;">Bill Qty.</th>
								<th width="50px;">Back Qty.</th>
								<th width="50px;">On-Hand</th>
								<th width="50px;">Avail</th>
								<template v-if="user.company_id == 'newjigu'">
									<th width="50px;">Pend30</th>
									<th width="50px;">Pend90</th>
								</template>

								<th width="50px;">Onboard</th>
								<th width="80px;">Arr Date.</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="item in bo_items" v-bind:key="item.invoice_item_no">
								<td class="al_center"><input type="checkbox" v-model="item.selected" /></td>
								<td class="al_left">{{ item.sales_group_code }}</td>
								<td class="al_left">{{ item.sales_group_name }}</td>
								<!-- <td class="al_left">{{ item.ship_to_code }}</td>
								<td class="al_left truncate" :title="item.ship_to_name">{{ item.ship_to_name }}</td>
								<td class="al_left">{{ item.bill_to_code }}</td>
								<td class="al_left truncate" :title="item.bill_to_name">{{ item.bill_to_name }}</td> -->
								<td class="al_left">{{ item.class_code }}</td>
								<td class="al_left truncate">{{ item.class_name }}</td>
								<td class="al_left" :style="item.active_yn == 'N' || item.so_blocked ? 'background-color: yellow;' : ''">
									<b v-if="item.active_yn == 'N'"><font color="red">!! </font></b><b v-if="item.so_blocked"><font color="red">B </font></b>{{ item.color_code }}
								</td>
								<td class="al_left">
									<a href="javascript:;">{{ item.so_dn }}</a>
								</td>
								<td class="al_left">{{ item.so_date }}</td>
								<td class="al_left">
									<a href="javascript:;">{{ item.invoice_dn }}</a>
								</td>
								<td class="al_left">{{ item.invoice_date }}</td>
								<td class="al_right">{{ item.unit_price | toCurrency }}</td>
								<td class="al_right">{{ item.quantity | commaSeparated }}</td>
								<td class="al_right">{{ item.shipped_quantity | commaSeparated }}</td>
								<td class="al_right">
									<font color="red">{{ item.bo_quantity | commaSeparated }}</font>
								</td>
								<td class="al_right">{{ item.on_hand | commaSeparated }}</td>
								<td class="al_right">{{ item.available_quantity | commaSeparated }}</td>
								<template v-if="user.company_id == 'newjigu'">
									<td class="al_right">{{ item.pending_30_quantity | commaSeparated }}</td>
									<td class="al_right">{{ item.pending_90_quantity | commaSeparated }}</td>
								</template>
								<td class="al_right">{{ item.on_board_quantity | commaSeparated }}</td>
								<td class="al_left">{{ item.arrival_date }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>

			<div class="view_bottom_bt">
				<a href="javascript:;" type="button" class="search_bt" @click="boOk()">Add & Close</a>
				<a href="javascript:;" type="button" class="gray_bt" @click="boClose()">Cancel</a>
			</div>
		</div>
	</div>
</template>

<script>
import '@/assets/css/table_box.css';
//import { apiSelectPartnerList } from '@/api/partner/index.js';
import { apiSelectBackOrderItemList } from '@/api/sales/invoice.js';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import { daysAgo, today } from '@/utils/date.js';
import _ from 'lodash';

export default {
	data: function() {
		return {
			bo_date_from: daysAgo(365),
			bo_date_to: today(),

			boAllSelected: false,
			bo_items: [],
		};
	},
	computed: {
		headers: function() {
			return { class: this.$session.get('headerClass') };
		},
		user: function() {
			return this.$session.get('user');
		},
	},
	props: {
		bo_ship_to_code: String,
	},
	components: {
		CustomDatePicker,
	},
	methods: {
		boOk() {
			//console.log(this.bo_items.filter(i => i.selected));
			//var selected_items = _.cloneDeep(this.bo_items.filter(i => i.selected));
			var selected_items = [];
			this.bo_items
				.filter(i => i.selected)
				.forEach(i => {
					//console.log(i, i.unit_price);
					selected_items.push(_.cloneDeep(i));
				});
			//console.log(selected_items);
			selected_items.forEach(i => {
				i.invoice_item_no = null;
				i.quantity = i.bo_quantity;
				i.net_price = i.unit_price;
				i.last_net_price = i.last_price;
				i.selected = false;
			});
			//var selected_items = this.items.filter(i => i.selected);
			//console.log(selected_items);
			if (selected_items.filter(i => i.active_yn == 'Y' && !i.so_blocked).length == 0) {
				this.$toast.error('No valid items selected.');
				return;
			}

			if (selected_items.filter(i => i.active_yn == 'N' || i.so_blocked).length > 0) {
				var item_list_str = '';
				selected_items
					.filter(i => i.active_yn == 'N' || i.so_blocked)
					.forEach(i => {
						item_list_str += i.class_code + ' ' + i.color_code + '<br/>';
					});

				this.$alertify.confirm('In-Active or Blocked item(s) will be excluded. Proceed? <br/><br/>Invalid Item List<br/><br/>' + item_list_str, () => {
					this.boOkConfirm(selected_items.filter(i => i.active_yn == 'Y' && !i.so_blocked));
				});

				//return;
			} else {
				this.boOkConfirm(selected_items);
			}
		},
		boOkConfirm(items_to_add) {
			//console.log(items_to_add);
			this.$emit('set-items', items_to_add);
			this.boClose();
		},
		selectBoAll() {
			var vm = this;
			this.bo_items.forEach(function(item) {
				item.selected = vm.boAllSelected;
			});
		},
		boReset() {
			this.bo_date_from = daysAgo(365);
			this.bo_date_to = today();
		},
		boSearch() {
			this.selectBackOrderItems();
		},
		async selectBackOrderItems() {
			var param = {
				paging_yn: 'N',

				invoice_date_from: this.bo_date_from,
				invoice_date_to: this.bo_date_to,
				ship_to_code: this.bo_ship_to_code,
			};

			const { data } = await apiSelectBackOrderItemList(param);

			this.bo_items = data.itemList;
			//console.log(this.bo_items);
			this.list_count = this.bo_items.length;
		},

		async index() {},

		async init() {
			//await this.index();
			this.boSearch();
		},

		boClose() {
			this.$emit('close');
		},
	},
	created() {
		this.init();
	},
};
</script>

<style></style>
